const Yup = require('yup');

const subjectOptions = ['ict', 'design', 'sale', 'request', 'other'];
const CONTACT_MESSAGE_MAX_LENGTH = 2000;
const APPLICATION_MESSAGE_MAX_LENGTH = 3000;

const phoneValidation = Yup.string()
    .required('Required')
    .test('valid-phone-number', 'Invalid phone number', (value) => {
        if (!value) {
            return false;
        }

        const normalized = value.replace(/[\s().-]/g, '');
        const hasValidCharacters = /^\+?\d+$/.test(normalized);
        const digitCount = normalized.replace(/^\+/, '').length;

        return hasValidCharacters && digitCount >= 7 && digitCount <= 15;
    });

const contactValidationSchema = Yup.object({
    firstName: Yup.string().required('Required').min(1, 'Too short').max(30, 'Too long'),
    lastName: Yup.string().required('Required').min(1, 'Too short').max(30, 'Too long'),
    email: Yup.string().required('Required').email('Invalid email address'),
    subject: Yup.string().required('Required').oneOf(subjectOptions, 'Invalid subject'),
    message: Yup.string().required('Required').min(10, 'Message too short').max(CONTACT_MESSAGE_MAX_LENGTH, 'Message too long'),
    privacyPolicyAccepted: Yup.boolean().oneOf([true], 'Required'),
});

const ictApplicationValidationSchema = Yup.object({
    firstName: Yup.string().required('Required').min(1, 'Too short').max(30, 'Too long'),
    lastName: Yup.string().required('Required').min(1, 'Too short').max(50, 'Too long'),
    phone: phoneValidation,
    email: Yup.string().required('Required').email('Invalid email address'),
    degree: Yup.string().required('Required').min(2, 'Too short').max(50, 'Too long'),
    message: Yup.string().required('Required').min(10, 'Message too short').max(APPLICATION_MESSAGE_MAX_LENGTH, 'Message too long'),
    privacyPolicyAccepted: Yup.boolean().oneOf([true], 'Required'),
});

const electricalApplicationValidationSchema = Yup.object({
    firstName: Yup.string().required('Required').min(1, 'Too short').max(30, 'Too long'),
    lastName: Yup.string().required('Required').min(1, 'Too short').max(50, 'Too long'),
    phone: phoneValidation,
    email: Yup.string().required('Required').email('Invalid email address'),
    degree: Yup.string().required('Required').min(2, 'Too short').max(50, 'Too long'),
    message: Yup.string().required('Required').min(10, 'Message too short').max(APPLICATION_MESSAGE_MAX_LENGTH, 'Message too long'),
    privacyPolicyAccepted: Yup.boolean().oneOf([true], 'Required'),
});

const automationApplicationValidationSchema = Yup.object({
    firstName: Yup.string().required('Required').min(1, 'Too short').max(30, 'Too long'),
    lastName: Yup.string().required('Required').min(1, 'Too short').max(50, 'Too long'),
    phone: phoneValidation,
    email: Yup.string().required('Required').email('Invalid email address'),
    degree: Yup.string().required('Required').min(2, 'Too short').max(50, 'Too long'),
    message: Yup.string().required('Required').min(10, 'Message too short').max(APPLICATION_MESSAGE_MAX_LENGTH, 'Message too long'),
    privacyPolicyAccepted: Yup.boolean().oneOf([true], 'Required'),
});

const technicianApplicationValidationSchema = Yup.object({
    firstName: Yup.string().required('Required').min(1, 'Too short').max(30, 'Too long'),
    lastName: Yup.string().required('Required').min(1, 'Too short').max(50, 'Too long'),
    phone: phoneValidation,
    email: Yup.string().required('Required').email('Invalid email address'),
    degree: Yup.string().required('Required').min(2, 'Too short').max(50, 'Too long'),
    message: Yup.string().required('Required').min(10, 'Message too short').max(APPLICATION_MESSAGE_MAX_LENGTH, 'Message too long'),
    privacyPolicyAccepted: Yup.boolean().oneOf([true], 'Required'),
});

module.exports = {
    contactValidationSchema,
    ictApplicationValidationSchema,
    electricalApplicationValidationSchema,
    automationApplicationValidationSchema,
    technicianApplicationValidationSchema
};
